import { NgFor, NgIf } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { checkModifica } from 'app/utils/boolean-input';

@Component({
  selector: 'sl-footer-menu',
  standalone: true,
  imports: [MatIconModule, NgIf, NgFor],
  templateUrl: './footer-menu.component.html',
})
export class FooterMenuComponent{


    @Input() data:any;

    SVG_ICONS=["heroicons_outline:building-library","heroicons_outline:calendar","heroicons_outline:cog-8-tooth",""]

    checkModifica(){
        return checkModifica()
    }





}
